/**
 * KAN-744: текст ошибки закрепления менеджера под селектом: 400 с текстом
 * поля manager_id ("Менеджер не найден или в архиве."), 403 и прочее.
 */
import { isAxiosError } from 'axios';
import { extractErrorMessage } from '@/lib/extractErrorMessage';

export const ASSIGN_FORBIDDEN = 'Недостаточно прав, чтобы менять менеджера';

export function assignErrorMessage(err: unknown): string | null {
  if (!err) return null;
  if (isAxiosError(err) && err.response?.status === 403) {
    const detail = (err.response.data as { detail?: string } | undefined)?.detail;
    return detail || ASSIGN_FORBIDDEN;
  }
  return extractErrorMessage(err, 'Не удалось сохранить менеджера');
}
